import { Card, Col, Container, Row } from "react-bootstrap";
import { useLoaderData, useNavigate } from "react-router-dom";
import { Payment           } from "./Data/ApiTypes";
import { PageTitle         } from "./Controls/PageTitle";
import { showMoney         } from "./Data/Money";
import { facilityImg       } from "./Data/Common";
import { showPaymentType   } from "./Data/Finance";
import { showInstantDate   } from "./Data/Date";

export function UserPaymentsPage() {
    const nav  = useNavigate();
    const pmts = useLoaderData() as Payment[];

    return <Container fluid>
        <Row>
            <Col>
                <PageTitle className="mb-1">
                    Payments
                </PageTitle>
                {pmts.length === 0 && <>
                    You haven't made any payments
                </>}
                {pmts.map( pmt => {
                    const facility = pmt.facility;
                    return <Card key={pmt.paymentId} className="mb-3"
                                 style={{ cursor: "pointer" }}
                                 onClick={() => nav(`/user/payment/${pmt.paymentId}`)}>
                        <Card.Header className="text-start d-flex align-items-center justify-content-between gap-2 py-1">
                            <span className="d-inline-flex align-items-center gap-2 rounded-pill px-2 py-1 small"
                                  style={{ color: 'var(--bs-body-color)' }}>
                                <span className="rounded-circle bg-success" style={{ width: 8, height: 8 }} aria-hidden />
                                {showPaymentType(pmt.type)}
                            </span>
                            <span className="text-muted small text-end">
                                {showInstantDate(pmt.paidWhen, facility.timeZone)}
                            </span>
                        </Card.Header>
                        <Card.Body className="purchase-layout gap-2">
                            <div className="grid-area-a">
                                <img className="facility-result-pic"
                                    src={facilityImg(facility.listImageId)}
                                    style={{ aspectRatio: "1 / 1", objectFit: "cover" }} />
                            </div>
                            <div className="grid-area-b d-flex flex-column justify-content-center my-2">
                                <div className="fw-bold">{facility.name}</div>
                                {facility.address && (
                                    <div className="text-muted small">
                                        {facility.address.city}{facility.address.city && facility.address.state ? ", " : ""}{facility.address.state}
                                    </div>
                                )}
                            </div>
                            <div className="grid-area-c" />
                        </Card.Body>
                        <Card.Footer className="d-flex align-items-center justify-content-between gap-2 flex-wrap py-1 bg-white">
                            <span className="text-muted small">
                                {pmt.paymentMethod}
                            </span>
                            <span className="fw-bold">{showMoney(pmt.remaining)}</span>
                        </Card.Footer>
                    </Card>;
                })}
            </Col>
        </Row>
    </Container>;
}
